export default function amountErrorState(submissionProps, MAXIMUM_AMOUNT) {
  if (submissionProps?.reAmount?.length) {
    if (
      MAXIMUM_AMOUNT > 0 &&
      Number(submissionProps.amount) > MAXIMUM_AMOUNT &&
      Number(submissionProps.reAmount) > MAXIMUM_AMOUNT
    ) {
      return {
        error: true,
        msg: `* Amount too large - max $${MAXIMUM_AMOUNT}`,
      };
    } else if (
      Number(submissionProps.amount) !== Number(submissionProps.reAmount)
    ) {
      return {
        error: true,
        msg: "* Amounts don't match",
      };
    } else {
      return {
        error: false,
      };
    }
  } else {
    return {
      error: false,
    };
  }
}
